import { getIn } from "formik";
import FormControl from "@ds/components/FormControl";
import Dropdown from "@ds/components/Dropdown";
import { TFieldDropdown } from "./type";

const FieldDropdown: React.FC<TFieldDropdown> = ({
  id,
  field,
  form,
  hint,
  FormControlProps,
  placeholder,
  value,
  options,
  label,
  width,
  disabled,
  optional,
  multiple,
  onChange
}) => {
  const { touched, errors, setFieldValue } = form;
  const isError = getIn(touched, field.name) && getIn(errors, field.name);

  return (
    <FormControl
      id={id}
      form={form}
      field={field}
      optional={optional}
      hint={hint}
      error={isError}
      label={label}
      {...FormControlProps}
    >
      <Dropdown
        value={value}
        placeholder={placeholder}
        options={options}
        width={width}
        disabled={disabled}
        multiple={multiple}
        onChange={(valueDropdown) => {
          setFieldValue([field.name], valueDropdown);
          onChange && onChange(valueDropdown);
        }}
      />
    </FormControl>
  );
};

export default FieldDropdown;
